import { takeEvery, call, put } from 'redux-saga/effects';
import { SubmissionError } from 'redux-form';
import request from '../api-utils/request';
import { showAlert } from './alert';
import actionKey from '../utils/action-key';

export const CREATE_TICKET = 'support-widget/CREATE_TICKET';
export const GET_ZENDESK_URL = 'support-widget/GET_ZENDESK_URL';

export const createTicketAction = ({ body, resolve, reject }) => ({
  type: CREATE_TICKET,
  resolve,
  reject,
  body,
});

export const getZendeskUrlAction = () => ({
  type: GET_ZENDESK_URL,
});

export function* rootSaga() {
  yield [
    takeEvery(CREATE_TICKET, createTicket),
    takeEvery(GET_ZENDESK_URL, getZendeskUrl),
  ];
}

export default function reducer(state = {}, action) {
  switch (action.type) {
  case actionKey.success(GET_ZENDESK_URL):
    return {
      ...state,
      ...action.payload,
    };
  default:
    return state;
  }
}

export function* createTicket({ type, body, resolve, reject }) {
  const result = yield call(request, {
    url: '/api/support/tickets',
    type,
    options: {
      method: 'POST',
      body,
    },
  });
  if (result.error && reject) {
    reject(new SubmissionError({
      _error: result.error,
    }));
  } else if (!result.error && resolve) {
    yield put(showAlert({
      title: 'Ticket created successfully',
      type: 'success',
      message: 'Your message has been received.',
      // button: 'Finish',
    }));
    resolve();
  }
  return result;
}

export function* getZendeskUrl({ type }) {
  yield call(request, {
    url: '/api/support/zendesk-login',
    type,
    options: {
      method: 'GET',
    },
  });
}



// WEBPACK FOOTER //
// ./src/client/redux/support-widget.js